// Trivia API helpers. Server owns all answer validation; client only shuffles UI.
import { api } from "./api";

export async function fetchTrivia() {
  const res = await api.get("/archive/trivia");
  return res.data;
}

export async function submitTrivia(attempt_id, answers) {
  const res = await api.post("/archive/trivia/submit", { attempt_id, answers });
  return res.data;
}

export async function submitSuperfanEmail(attempt_id, email) {
  const res = await api.post("/archive/trivia/superfan-email", { attempt_id, email });
  return res.data;
}
